import { create } from 'zustand';

export type BackKeyResult = boolean;
export type BackKeyInterceptor = () => BackKeyResult | Promise<BackKeyResult>;

type InterceptorType = 'page' | 'popup';
/**
 * 백키 인터셉터 정보
 */
interface BackKeyInterceptorInfo {
    type?: InterceptorType;
    interceptor: BackKeyInterceptor;
}

/**
 *
 */
interface BackKeyInterceptorState {
    interceptors: BackKeyInterceptorInfo[];
    register: (interceptor: BackKeyInterceptorInfo) => void;
    unregister: (interceptor: BackKeyInterceptor) => void;
    get: (type?: InterceptorType) => BackKeyInterceptor | undefined;
}

export const useBackKeyInterceptorStore = create<BackKeyInterceptorState>((set, get) => ({
    interceptors: [],
    register: (info: BackKeyInterceptorInfo) => {
        set((state) => {
            if (state.interceptors.find((i) => i.interceptor === info.interceptor)) return state;
            return {
                interceptors: [...state.interceptors, info],
            };
        });
    },

    /**
     *
     * @param fn
     */
    unregister: (fn: BackKeyInterceptor) => {
        set((state) => ({
            interceptors: state.interceptors.filter((h) => h.interceptor !== fn),
        }));
    },

    /**
     *
     * @returns
     */
    get: (type: InterceptorType = 'page') => {
        const { interceptors } = get();
        const filtered = interceptors.filter((i) => i.type === type);
        return filtered[filtered.length - 1]?.interceptor;
    },
}));
